<template>
  <input-base
    :input="input"
    :review-mode="reviewMode"
    :error="error"
    class="form-wrapper-company"
  >
    <div class="flex-1">
      <div v-if="!input.attributes.locked && !reviewMode">
        <input
          :id="
            input.key +
              (applicationValueIndex ? '_' + applicationValueIndex : '')
          "
          ref="input"
          v-model="company_number"
          type="text"
          class="mt-1 w-full"
          :name="
            input.key +
              (applicationValueIndex ? '_' + applicationValueIndex : '')
          "
          autocomplete="off"
          :maxlength="8"
          :placeholder="input.attributes.placeholder"
          :readonly="input.attributes.locked || reviewMode"
          :required="input.attributes.required"
          :blur="companyPrefixZero"
          v-on="$listeners"
        />
      </div>
      <div
        v-if="Object.keys(company_details).length"
        ref="input-locked"
        class="form-company-details"
        :class="{
          'mr-2 border-grey-300': input.attributes.locked || reviewMode,
          searched: !input.attributes.locked && !reviewMode,
          'bg-primary-100 border-primary-200': isUniversity,
          'bg-primary-100 border-primary-200' : ['active','open'].includes(companiesHouse.company_status) && !input.attributes.locked && !reviewMode,
          'bg-negative-100 border-negative-200' : !['active','open'].includes(companiesHouse.company_status) && !input.attributes.locked && !reviewMode,
        }"
      >
        <p
          class="text-2xs"
        >
          <span
            v-if="companiesHouse && companiesHouse.company_status"
            class="px-1 py-px uppercase font-bold tracking-wide inline-block -ml-1 -mt-px"
            :class="{
              'bg-primary-300 text-primary-800' : ['active','open'].includes(companiesHouse.company_status),
              'bg-negative-300 text-negative-800' : !['active','open'].includes(companiesHouse.company_status),
            }"
          >
            {{ companiesHouse.company_status }}
          </span>
          <span
            v-else
            class="px-1 py-px uppercase font-bold tracking-wide inline-block -ml-1 -mt-px bg-neutral-300 text-neutral-800"
          >
            Unverified
          </span>
        </p>
        <p class="text-sm -mb-2">
          {{ company_details.name }}
        </p>
        <p class="text-xs text-grey-700">
          {{ companyAddress }}
        </p>
        <template v-if="companiesHouse">
          <p
            class="text-xs font-bold"
            :class="{
              'text-negative-800': companiesHouse.date_of_cessation
            }"
          >
            Started trading {{ format(parseISO(companiesHouse.date_of_creation), 'dd/MM/yyyy') }}
            <template v-if="companiesHouse.date_of_cessation">
              | Ceased trading {{ format(parseISO(companiesHouse.date_of_cessation), 'dd/MM/yyyy') }}
            </template>
          </p>
        </template>
      </div>
      <p
        v-if="getError('company_number').length"
        class="form-company-error"
        v-html="$sanitizeHtml(getError('company_number').join(', '))"
      />
    </div>
    <icon-link
      v-if="$AuthUser.access_level === 'admin' && company_details.id"
      :href="route('companies.view', company_details.id)"
      target="_blank"
      icon="view-visible"
      class="mx-4 self-center"
    >
      View Company
    </icon-link>
  </input-base>
</template>

<script>
import { store } from "../../store/application";
import debounce from "lodash/debounce";
import pick from "lodash/pick";
import { inputHelperMixin } from "../../mixins/inputHelper";
import { requestMixin } from "../../mixins/request";
export default {
  name: "InputCompany",
  mixins: [inputHelperMixin, requestMixin],
  data() {
    return {
      company_number: "",
      company_details: {},
      dirtyInput: ""
    };
  },
  computed: {
    isUniversity() {
      return store?.universities.includes(this.company_number);
    },
    companyAddress() {
      let address = pick(this.company_details, [
        "address_line_1",
        "address_line_2",
        "town",
        "county",
        "postcode"
      ]);
      return Object.values(address)
        .filter(Boolean)
        .join(", ");
    },
    companiesHouse() {
      const ch = this.company_details?.companies_house_info ?? false;

      if (typeof ch == 'object') {
        return ch;
      }

      try {
        return JSON.parse(ch);
      } catch (e) {
        return false;
      }
    }
  },
  watch: {
    company_number: debounce(function() {
      if (this.input.attributes.locked || this.reviewMode) return;
      return this.companySearch();
    }, 500)
  },
  created() {
    this.setCompanyNumber();
    this.setCompanyDeatils();
  },
  methods: {
    setCompanyNumber() {
      if (!this.applicationValue) return;
      if (!this.applicationValue.hasOwnProperty("company_number")) {
        return (this.company_number = this.applicationValue);
      }
      return (this.company_number = this.applicationValue.company_number);
    },
    setCompanyDeatils() {
      if (!this.applicationValue) return;
      if (!this.applicationValue.hasOwnProperty("company_details")) {
        return (this.company_details = {});
      }
      return (this.company_details = this.applicationValue.company_details);
    },
    companyPrefixZero() {
      if (this.company_number.length === 7)
        return (this.company_number = 0 + this.company_number + "");
    },
    companySearch() {
      this.removeError("company_number");
      if (this.company_number.length !== 8) {
        this.company_details = {};
        return;
      }
      if (this.company_number === this.dirtyInput) return;
      this.dirtyInput = this.company_number;
      this.company_details = {};

      return axios
        .post(route("api.company-search"), {
          company_number: this.company_number
        })
        .then(response => this.companySearchResponse(response))
        .catch(error => this.requestError(error));
    },
    companySearchResponse(response) {
      this.company_details = { ...this.company_details, ...response.data };
      return this.updateInput(
        this.parentField,
        this.input.key,
        pick(this.$data, ["company_number", "company_details"])
      );
    }
  }
};
</script>

<style>
.form-wrapper-company .form-company-details {
  @apply mb-1 text-black;
}

.form-wrapper-company .form-company-details.searched {
  @apply mt-2 p-3 border border-dashed;
}

.form-wrapper-company .form-company-details p {
  @apply mb-1;
}

.form-wrapper-company .form-company-details p:last-child {
  @apply mb-0;
}

.form-wrapper-company .form-company-error {
  @apply w-full text-xs mb-0 mt-2 italic text-negative-600;
}
</style>
